function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -.277)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 .277h263V180H0z"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "family--green_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .277h263V180H0z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#family--green_svg__a)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .277)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.584 98.064L95.44 173.81c1.592 2.751-.4 6.19-3.585 6.19H4.145c-3.186 0-5.176-3.439-3.585-6.19l43.855-75.746c1.594-2.752 5.575-2.752 7.17 0",
  fill: "#0ac700"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 48,
  cy: 48,
  rx: 48,
  ry: 47.723,
  fill: "#ff7d13"
}), /*#__PURE__*/React.createElement("path", {
  d: "M218.584 98.064l43.856 75.746c1.592 2.751-.4 6.19-3.585 6.19h-87.71c-3.186 0-5.176-3.439-3.585-6.19l43.855-75.746c1.594-2.752 5.575-2.752 7.17 0",
  fill: "#0ac700"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 48,
  cy: 48,
  rx: 48,
  ry: 47.723,
  fill: "#ff7d13",
  transform: "translate(167)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.59 132.204l25.583 44.185c.93 1.605-.232 3.611-2.091 3.611h-51.164c-1.859 0-3.02-2.006-2.091-3.611l25.582-44.185c.93-1.605 3.252-1.605 4.182 0",
  fill: "#0ac700"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 28,
  cy: 28,
  rx: 28,
  ry: 27.838,
  fill: "#ff7d13",
  transform: "translate(103.5 75)"
}))));

function SvgFamilyGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 263 180"
  }, props), _ref);
}

export default SvgFamilyGreen;